import * as Contentful from 'contentful'
import { TypeHeader } from './header'
import { TypeSectionGroup } from './section-group'
import { TypeSectionGrammarCheck } from './section-grammar-check'
import { TypeSectionHero } from './section-hero'
import { TypeSeoMetadata } from './seo-metadata'
import { AnySection } from './section'
import { TypeSocialMetadata } from './social-metadata'
import { TypeSectionCitationGenerator } from './section-citation-generator'
import { TypePageTemplateCitation } from './page-template-citation'
import { TypeSectionDynamic } from './section-dynamic'
import { TypeBannerComponent } from './component-banner'

export type AllowedPageSection = Omit<AnySection, 'TypeSectionHero'>

export enum PageSwoosh {
  Egg = 'Egg',
  Ribbon = 'Ribbon',
  Wave = 'Wave',
  Butterfly = 'Butterfly',
  Peach = 'Peach',
  Ukraine = 'Ukraine',
  GrammarlyGO = 'GrammarlyGO',
  GrammarlyGODiamond = 'GrammarlyGODiamond',
  Rope = 'Rope',
  Grid = 'Grid',
  Clouds = 'Clouds',
}

export type HeroSectionType =
  | TypeSectionHero
  | TypeSectionGroup
  | TypeSectionGrammarCheck
  | TypeSectionCitationGenerator
  | TypeSectionDynamic

export interface TypePageFields {
  pageId: Contentful.EntryFields.Symbol
  isPageWidth1280?: Contentful.EntryFields.Boolean
  useWdk2023Colors?: Contentful.EntryFields.Boolean
  useWdk2023Typography?: Contentful.EntryFields.Boolean
  isSectionScrollTrackingEnabled?: Contentful.EntryFields.Boolean
  isDiscountBannerEnabled?: Contentful.EntryFields.Boolean
  isGoogleOneTapEnabled?: Contentful.EntryFields.Boolean
  isFullStoryEnabled?: Contentful.EntryFields.Boolean
  isDriftEnabled?: Contentful.EntryFields.Boolean
  reducedHeroPadding?: Contentful.EntryFields.Boolean
  seoMetadata?: TypeSeoMetadata
  socialMetadata?: TypeSocialMetadata
  header: TypeHeader
  showBreadcrumbs?: Contentful.EntryFields.Boolean
  heroSection?: HeroSectionType
  sections?: AllowedPageSection[]
  swoosh?: PageSwoosh
  pageTemplate?: TypePageTemplateCitation
  banner?: TypeBannerComponent
}

export type TypePage = Contentful.Entry<TypePageFields>
